import http from "../helpers/http-common"

class GeneratorService {

    search(params) {
        return http.post(`/generator/search`, params);
    }

    getStats(params) {
        return http.post(`/generator/stats`, params);
    }

    getList(params) {
        return http.post(`/generator/list`, params);
    }

    searchAnswersMatches(params) {
        return http.post(`/generator/answers-matches-search`, params);
    }

    searchAnswersIceBreakers(params) {
        return http.post(`/generator/answers-icebreakers-search`, params);
    }

    searchAnswersChatRooms(params) {
        return http.post(`/generator/answers-chatrooms-search`, params);
    }

    getAnswersMatchesList(params) {
        return http.post(`/generator/answers-matches-list`, params);
    }

    getAnswersIceBreakersList(params) {
        return http.post(`/generator/answers-icebreakers-list`, params);
    }

    getAnswersChatRoomsList(params) {
        return http.post(`/generator/answers-chatrooms-list`, params);
    }

    getAnswersMatchesStats(params) {
        return http.post(`/generator/answers-matches-stats`, params);
    }

    getAnswersIceBreakersStats(params) {
        return http.post(`/generator/answers-icebreakers-stats`, params);
    }

    getAnswersChatRoomsStats(params) {
        return http.post(`/generator/answers-chatrooms-stats`, params);
    }
}

export default new GeneratorService();
